// IMPORTANT: This file is auto generated from writePlaygroundPages
// Any changes you make to this file here will be overwritten.

import * as React from 'react';
import { PlaygroundWrapper } from '../Playground_SC';
import { ErrorBoundary } from '../../../utils/ErrorBoundary';
import { DataOverrides } from '../../../manual-data/component-data/DataOverrides';
import { HorizontalTabBar, HorizontalTabBar_onTabChangeEvent, XISVG } from '@inmoment/the-kitchen';
import { _dataXISVG } from '@inmoment/the-kitchen-data';

import { PropChangers } from '../../automated-pages-utils/PropChangers/PropChangers';
import { ComponentWrapper } from '../ComponentWrapper_SC';
import { TABS, PageType } from '../../../utils/copy';
import { KitchenThemeContext } from '../../../App';
import { XISVGSnippet } from '../code-snippets/XISVGSnippet';
import {
  formatPropObjectForReact,
  formatPropObjectForWeb,
  formatPropObjectForAngular,
} from '../../automated-pages-utils/code-snippet-utils/codeFormattingFns';

export const XISVGPlayground = () => {
  const { theme } = React.useContext(KitchenThemeContext);
  const [pageType, setPageType] = React.useState<PageType>('Playground');

  const [propObj, setPropObj] = React.useState<Parameters<typeof XISVG>[0]>({
    ..._dataXISVG,

    ...DataOverrides.XISVG,
  });
  const [componentWrapperElement, setComponentWrapperElement] = React.useState<HTMLDivElement | null>(null);

  let toDisplay: JSX.Element | null = null;
  if (pageType === 'Playground') {
    toDisplay = (
      <ComponentWrapper align="center" ref={setComponentWrapperElement}>
        <XISVG {...propObj}></XISVG>
      </ComponentWrapper>
    );
  } else if (pageType === 'React') {
    toDisplay = <XISVGSnippet propObj={propObj} formattingFunction={formatPropObjectForReact} lang="js" />;
  } else if (pageType === 'Web') {
    toDisplay = <XISVGSnippet propObj={propObj} formattingFunction={formatPropObjectForWeb} lang="html" />;
  } else if (pageType === 'Angular') {
    toDisplay = <XISVGSnippet propObj={propObj} formattingFunction={formatPropObjectForAngular} lang="html" />;
  }

  const handleTabChange = ({ tab }: HorizontalTabBar_onTabChangeEvent) => {
    const title = tab.title;
    if (title.includes('Playground')) {
      setPageType('Playground');
    } else if (title.includes('React')) {
      setPageType('React');
    } else if (title.includes('Web Component')) {
      setPageType('Web');
    } else if (title.includes('Angular')) {
      setPageType('Angular');
    }
  };

  return (
    <>
      <div style={{ height: 46 }}>
        <HorizontalTabBar stretch data={TABS} tabSpacing={40} color={theme} onTabChange={handleTabChange} activeTabId={pageType} />
      </div>
      <hr className="no-margin" />
      <PlaygroundWrapper isSun={false}>
        <ErrorBoundary>
          {toDisplay}

          <PropChangers
            componentName="XISVG"
            componentWrapperElement={componentWrapperElement}
            category="Visuals"
            propObj={propObj}
            setPropObj={setPropObj}
          />
        </ErrorBoundary>
      </PlaygroundWrapper>
    </>
  );
};
